import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

interface TransactionSuccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  message: string;
  buttonText?: string;
  onDone?: () => void;
}

export default function TransactionSuccessDialog({
  open,
  onOpenChange,
  title = "Transaction Successful",
  message,
  buttonText = "Done",
  onDone,
}: TransactionSuccessDialogProps) {
  const handleDone = () => {
    onDone?.();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="items-center text-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-emerald-500/10">
            <CheckCircle2 className="h-12 w-12 text-emerald-500" />
          </div>

          <DialogTitle className="mt-4 text-2xl font-bold">{title}</DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          <p className="text-center text-muted-foreground">{message}</p>

          <Button className="w-full h-11" onClick={handleDone}>
            {buttonText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
